import { AddressField } from '@uncinc/react-drupal-core/types';
import { GOOGLE_MAPS_SEARCH_LINK } from '../config/constants';

/**
 * Generate a google maps link.
 *
 * @param {AddressField} address
 * @param {string} name
 * @returns {string} Google maps link for given address.
 */
const addressMapsLink = (address: AddressField, name?: string): string => {
  const {
    address_line1: addressLine,
    postal_code: postalCode,
    locality: city,
    country_code: countryCode,
  } = address;

  const parts = [
    name,
    addressLine,
    postalCode,
    city,
    countryCode,
  ].filter((val) => val && val.length > 0);

  const params = new URLSearchParams();
  params.append('api', '1');
  params.append('query', parts.join(', '));

  return `${String(GOOGLE_MAPS_SEARCH_LINK)}?${params.toString()}`;
};

export default addressMapsLink;
